// Translation: Account > Settings > Password (Ukrainian)
export default Object.freeze({
	actions: {
		change: 'Change password'
	},
	header: {
		title: ''
	}
})
